import { Core } from "@faire/design-tokens";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { getSpacing } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import * as React from "react";
import type { JSX } from "react";
import styled, { css } from "styled-components";

import { animated } from "@faire/retailer/components/GhostLoading/animated";

interface INoResultsEmptyStateProps {
  title: JSX.Element;
  subtitle: JSX.Element;
  className?: string;
  divRef?: React.Ref<HTMLDivElement>;
}

export const NoResultsEmptyStateBase = ({
  title,
  subtitle,
  className,
  divRef,
}: INoResultsEmptyStateProps) => {
  return (
    <AnimatedNoResults className={className}>
      <div ref={divRef}>
        <Typography variant="paragraphSansMedium">{title}</Typography>
        <Spacer height="1x" />
        <Typography align="center">{subtitle}</Typography>
      </div>
    </AnimatedNoResults>
  );
};

const NoResultsFilteredArea = styled(Column).attrs({
  align: "center",
  justify: "center",
})`
  padding: ${getSpacing(136, "2x")};
  width: 100%;
  text-align: center;
  background-color: ${Core.surface.muted};
`;

const AnimatedNoResults = animated(NoResultsFilteredArea)({
  initialStyle: css`
    opacity: 0;
  `,
  loadedStyle: css`
    opacity: 1;
  `,
});
